import { render, staticRenderFns } from "./WidgetKeyResultWeights.vue?vue&type=template&id=73b9c416&scoped=true&"
import script from "./WidgetKeyResultWeights.vue?vue&type=script&lang=js&"
export * from "./WidgetKeyResultWeights.vue?vue&type=script&lang=js&"
import style0 from "./WidgetKeyResultWeights.vue?vue&type=style&index=0&id=73b9c416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b9c416",
  null
  
)

export default component.exports